// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { isGLOP } from './utils/feature-flag-utils'
import { localStorageWhitelistWithoutPII } from './utils/local-storage-utils'

const url = `${window.location.protocol}//${window.location.host}`

const evaluateIsNewLoginFlow = (enableNewLogin) => {
  // Evaluate localStorate LD Flag strategy
  const localStorageFlag = localStorage.getItem(
    localStorageWhitelistWithoutPII.NEW_LOGIN_FLOW
  )
  // Evaluate deeplink with /newlogin strategy
  let initiatedWithNewLogin = sessionStorage.getItem('initiated-with-new-login')
  if (enableNewLogin && window.location.pathname === '/newlogin') {
    initiatedWithNewLogin = true
    sessionStorage.setItem('initiated-with-new-login', true)
  }
  // Final evaluation with global settings
  const isNewLoginFlow =
    enableNewLogin && (localStorageFlag || initiatedWithNewLogin)
  return isNewLoginFlow
}

const getOIDCConfig = (authorityURL, enableNewLogin = true) => {
  const glcpOauthIssuer = `${window.$settings.oauthIssuer}`
  const isNewLoginFlow = evaluateIsNewLoginFlow(enableNewLogin)
  const metadata = isNewLoginFlow
    ? {
        // new issuer config
        issuer: glcpOauthIssuer,
        jwks_uri: `${glcpOauthIssuer}/keys`,
        ping_end_session_endpoint: `${glcpOauthIssuer}/logout`,
        end_session_endpoint: `${glcpOauthIssuer}/logout`,
        authorization_endpoint: `${glcpOauthIssuer}/authorize`,
        token_endpoint: `${glcpOauthIssuer}/token`,
        ping_revoked_sris_endpoint: `${authorityURL}/pf-ws/rest/sessionMgmt/revokedSris`,
        revocation_endpoint: `${authorityURL}/as/revoke_token.oauth2`,
        userinfo_endpoint: `${glcpOauthIssuer}/userinfo`,
        introspection_endpoint: `${authorityURL}/as/introspect.oauth2`,
        backchannel_authentication_endpoint: `${authorityURL}/as/bc-auth.ciba`
      }
    : {
        // Existing config
        issuer: authorityURL,
        jwks_uri: `${authorityURL}/pf/JWKS`,
        ping_end_session_endpoint: `${authorityURL}/idp/startSLO.ping`,
        end_session_endpoint: `${authorityURL}/idp/startSLO.ping`,
        authorization_endpoint: `${authorityURL}/as/authorization.oauth2`,
        token_endpoint: `${authorityURL}/as/token.oauth2`,
        ping_revoked_sris_endpoint: `${authorityURL}/pf-ws/rest/sessionMgmt/revokedSris`,
        revocation_endpoint: `${authorityURL}/as/revoke_token.oauth2`,
        userinfo_endpoint: `${authorityURL}/idp/userinfo.openid`,
        introspection_endpoint: `${authorityURL}/as/introspect.oauth2`,
        backchannel_authentication_endpoint: `${authorityURL}/as/bc-auth.ciba`
      }

  const defaultConfig = {
    authority: authorityURL,
    client_id: window.$settings.client_id,
    redirect_uri: `${url}/authentication/callback`,
    response_type: 'code',
    post_logout_redirect_uri: url,
    scope: 'openid profile email',
    silent_redirect_uri: `${url}/authentication/silent_callback`,
    automaticSilentRenew: true,
    loadUserInfo: true,
    metadata,
    extraQueryParams: {
      new_login: isNewLoginFlow,
      origin: window.location.host
    }
  }
  const currentLPUser = sessionStorage.getItem('current-lp-user')
  const updatedConfig = {
    ...defaultConfig,
    extraQueryParams: { login_hint: currentLPUser }
  }
  return isGLOP() && currentLPUser ? updatedConfig : defaultConfig
}

export default getOIDCConfig
